import { type ReactNode } from 'react';

import { cx } from '@/lib/cx';

interface EstadoVazioProps {
  icone: ReactNode;
  titulo: string;
  /** Diz o próximo passo, não só que está vazio. */
  texto: ReactNode;
  acao?: ReactNode;
  tom?: 'neutro' | 'perigo';
  className?: string;
}

export function EstadoVazio({
  icone,
  titulo,
  texto,
  acao,
  tom = 'neutro',
  className,
}: EstadoVazioProps) {
  return (
    <div
      className={cx(
        'mx-auto grid max-w-md justify-items-center gap-3 px-6 py-14 text-center',
        className,
      )}
    >
      <div
        className={cx(
          'grid size-12 place-items-center rounded-cartao [&_svg]:size-5',
          tom === 'perigo' ? 'bg-perigo-suave text-perigo' : 'bg-marca-suave text-marca',
        )}
        aria-hidden
      >
        {icone}
      </div>
      <h2 className="text-lg font-semibold">{titulo}</h2>
      <p className="text-sm text-texto-suave">{texto}</p>
      {acao && <div className="pt-1">{acao}</div>}
    </div>
  );
}
